var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.22168 6.99707C0.22168 7.2168 0.318359 7.42773 0.494141 7.59473L6.00488 13.0967C6.18066 13.2637 6.37402 13.3428 6.58496 13.3428C7.0332 13.3428 7.36719 13.0176 7.36719 12.5693C7.36719 12.3496 7.28809 12.1475 7.14746 12.0068L5.28418 10.1084L2.60352 7.67383L4.59863 7.79688H14.9609C15.4355 7.79688 15.7607 7.46289 15.7607 6.99707C15.7607 6.52246 15.4355 6.18848 14.9609 6.18848H4.59863L2.6123 6.31152L5.28418 3.87695L7.14746 1.97852C7.28809 1.83789 7.36719 1.63574 7.36719 1.41602C7.36719 0.967773 7.0332 0.642578 6.58496 0.642578C6.37402 0.642578 6.18066 0.72168 5.9873 0.90625L0.494141 6.39062C0.318359 6.55762 0.22168 6.76855 0.22168 6.99707Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNavigationIcon);
export default __webpack_public_path__ + "static/media/back-navigation-icon.4a7b7ac744938a2f475449f52db29b01.svg";
export { ForwardRef as ReactComponent };